<template>
  <or-sidebar
    data-component="base-settings-menu-sidebar"
    placement="left"
    :resizeable="false"
    :width="SIDEBAR_WIDTH"
  >
    <div class="menu-groups">
      <base-settings-menu-group
        v-for="group in menuGroups"
        :key="group.title"
        :group="group"
        :active-item-id="activeMenuItemId"
        @item-click="$emit('item-click', $event)"
      />
    </div>
  </or-sidebar>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { OrSidebarV3 as OrSidebar } from '@onereach/ui-components-25';

import { MenuItemGroup } from '../types';
import BaseSettingsMenuGroup from './BaseSettingsMenuGroup.vue';

export default defineComponent({
  name: 'BaseSettingsMenuSidebar',
  components: { OrSidebar, BaseSettingsMenuGroup },
  props: {
    menuGroups: {
      type: Array as PropType<MenuItemGroup[]>,
      default: () => [],
    },
    activeMenuItemId: {
      type: String,
      default: '',
    },
  },
  emits: ['item-click'],
  data() {
    return { SIDEBAR_WIDTH: 240 };
  },
});
</script>

<style lang="scss" scoped>
[data-component='base-settings-menu-sidebar'] {
  .menu-groups {
    display: flex;
    flex-direction: column;
    gap: var(--s-5);
  }
}
</style>
